import { mdiBellRingOutline } from '@mdi/js'

export default {
  title: 'Announcement',
  to: 'announcement-school-list',
  icon: mdiBellRingOutline,
  resource: 'AnnouncementSchool',
  action: 'read',
}
